module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "p1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("First US edition")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("Copyright © 2018 by Bastei Lübbe AG, Köln")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("English translation copyright © 2020 by John Brownjohn")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("First published in Germany in 2018 as "), _c('em', [_vm._v("Tante Poldi und der schöne Antonio")]), _vm._v(" by Bastei Lübbe AG, Köln")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("First English-language edition published in Great Britain in 2020 by John Murray Publishers, a Hachette UK company")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to "), _c('a', {
    attrs: {
      "href": "mailto:trade.permissions@hmhco.com"
    }
  }, [_vm._v("trade.permissions@hmhco.com")]), _vm._v(" or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('a', {
    attrs: {
      "href": "https://hmhbooks.com/",
      "target": "_blank"
    }
  }, [_vm._v("hmhbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_c('em', [_vm._v("Library of Congress Cataloging-in-Publication Data")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Names: Giordano, Mario, 1963–author. | Brownjohn, John, translator.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Title: Auntie Poldi and the handsome Antonio / Mario Giordano ; translated by John Brownjohn.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Other titles: Tante Poldi und der schöne Antonio. English")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Description: First US edition. | Boston : Mariner Books/Houghton Mifflin Harcourt, 2020. | Series: Auntie Poldi series | First published in German in 2018 as Tante Poldi und der schöne Antonio by Bastei Lübbe AG, Köln. First English-language edition published in Great Britain in 2020 by John Murray Publishers, a Hachette UK company. | Translated from the German.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2019025609 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCCN")]), _vm._v(" 2019025610 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358309420 (trade paperback) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9781328518446 (hardcover) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9781328518415 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358309369 | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISBN")]), _vm._v(" 9780358309369")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Subjects: | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GSAFD:")]), _vm._v(" / Mystery fiction.")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC PT")]), _vm._v("2667."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("I")]), _vm._v("5617 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T")]), _vm._v("3413 2020 (print) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LCC PT")]), _vm._v("2667."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("I")]), _vm._v("5617 (ebook) | "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DDC")]), _vm._v(" 833/.92—"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("DC")]), _vm._v("23")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("LC record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2019025609",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019025609")])]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("LC ebook record available at "), _c('a', {
    attrs: {
      "href": "https://lccn.loc.gov/2019025610",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2019025610")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("Cover design by Martha Kennedy")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Cover illustration © Chris Andrews")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Hand lettering © Erik Marinovich")]), _vm._v(" "), _c('p', {
    staticClass: "left "
  }, [_vm._v("Author photograph © Rica Rosa")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("v1.0720")]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove1"
  }, [_vm._v("All characters in this book are fictitious, and any resemblance to real persons, living or dead, is purely coincidental.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2081d925","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front01.vue
// module id = 63
// module chunks = 0